import { chargesListTypes } from './actionTypes';

const INIT_STATE = {
  data: [],
  isLoading: false,
  error: {},
};

const chargesList = (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case chargesListTypes.GET_CHARGESLIST:
      return {
        ...state,
        isLoading: true,
      };

    case chargesListTypes.GET_CHARGESLIST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };

    case chargesListTypes.GET_CHARGESLIST_FAIL:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      };

    default:
      return state;
  }
};

export default chargesList;
